import React from 'react';
export function Footer() {
  return <footer className="bg-gray-800 text-white py-6" data-id="element-11">
      <div className="container mx-auto px-4 md:px-8" data-id="element-12">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-13">
          <div className="mb-4 md:mb-0" data-id="element-14">
            <p className="text-sm" data-id="element-15">
              © 2024 Professional Driver Safety Report. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-6" data-id="element-16">
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-17">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-18">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white" data-id="element-19">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>;
}